var _path, _path2, _path3, _circle, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReduceStockOutComerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 72,
    viewBox: "0 0 82 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L20.9556 8.31853C21.3112 8.43708 21.5707 8.74462 21.6277 9.11516L27.9155 49.9893C27.9905 50.4771 28.4103 50.8372 28.9038 50.8372H69.6274C70.0691 50.8372 70.4584 50.5475 70.5853 50.1246L80.1389 18.2791",
    stroke: "#1B1E59",
    strokeWidth: 2.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3725 72C39.4183 72 42.698 68.7202 42.698 64.6744C42.698 60.6286 39.4183 57.3488 35.3725 57.3488C31.3266 57.3488 28.0469 60.6286 28.0469 64.6744C28.0469 68.7202 31.3266 72 35.3725 72ZM35.3725 69.6744C38.1339 69.6744 40.3725 67.4359 40.3725 64.6744C40.3725 61.913 38.1339 59.6744 35.3725 59.6744C32.611 59.6744 30.3725 61.913 30.3725 64.6744C30.3725 67.4359 32.611 69.6744 35.3725 69.6744Z",
    fill: "#1B1E59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4545 72C66.5003 72 69.7801 68.7202 69.7801 64.6744C69.7801 60.6286 66.5003 57.3488 62.4545 57.3488C58.4087 57.3488 55.1289 60.6286 55.1289 64.6744C55.1289 68.7202 58.4087 72 62.4545 72ZM62.4545 69.6744C65.2159 69.6744 67.4545 67.4359 67.4545 64.6744C67.4545 61.913 65.2159 59.6744 62.4545 59.6744C59.6931 59.6744 57.4545 61.913 57.4545 64.6744C57.4545 67.4359 59.6931 69.6744 62.4545 69.6744Z",
    fill: "#1B1E59"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.0095,
    cy: 25.6396,
    r: 16.2791,
    fill: "#05F29B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41.0703,
    y: 17.8018,
    width: 2.25,
    height: 24.4186,
    rx: 1.125,
    transform: "rotate(-45 41.0703 17.8018)",
    fill: "#1B1E59"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58.8477,
    y: 16.2108,
    width: 2.25,
    height: 24.4186,
    rx: 1.125,
    transform: "rotate(45 58.8477 16.2108)",
    fill: "#1B1E59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReduceStockOutComerce);
export default __webpack_public_path__ + "static/media/Icon_ReduceStockOutComerce.f1bdc6955a7dc443bfe63869b615cc7b.svg";
export { ForwardRef as ReactComponent };